<template>
  <div class="printTransferCode column-me">
    <div class="row-me overflow-auto" v-dragscroll.x="true">
      <div class="column-me row-center margin-right30" @click="clickTab(item)" v-for="(item,index) in personArray"
           :key="index">
        <div class="tab-title" :class="{'tab-title-active':selectItem.id===item.id}">{{ item.patientName }}</div>
        <div class="tab-line" :class="{'tab-line-active':selectItem.id===item.id}"></div>
      </div>
    </div>
    <div class="line-grey-heng"></div>
    <div class="row-me row-center margin-top30 padding-bottom30">
      <div>打印数量：</div>
      <div class="width200">
        <el-input placeholder="请输入" style="width: 100%;" clearable v-model="selectItem.doseNums"
                  @input="numberChange"></el-input>
      </div>
      <div class="btn-blue width100 btn-height40 margin-left50" @click="clickPrint">
        打印
      </div>
    </div>
    <div :id="'print'+selectItem.id" class="flex1 overflow-auto" v-dragscroll.y="true"
         v-if="!this.$method.isEmptyOrZero(selectItem.doseNums)">
      <div class="column-me row-center" v-for="(item,index) in Number(selectItem.doseNums)"
           :key="index" style="page-break-after: always;">
        <div style="font-size: 15px;margin-top: 10px;">
          <div>{{ selectItem.hospitalName }}</div>
          <div>{{ selectItem.patientName }}</div>
          <svg :id="'barcode'+selectItem.id"></svg>
        </div>
      </div>
    </div>
    <button v-show="false" id="printTransferCodeId" v-print="printContent"></button>
  </div>
</template>

<script>
let JsBarcode = require('jsbarcode')
export default {
  components: {},
  props: {
    persons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectItem: {},
      personArray: this.persons,
      printContent: {
        id: "", // 打印的区域
        preview: false, // 预览工具是否启用
      },
    }
  },
  // 侦听器
  watch: {
    "selectItem.doseNums"(val, oldVal) {
      if (!this.$method.isEmptyOrZero(val)) {
        this.$nextTick(() => {
          //条形码
          JsBarcode("#barcode" + this.selectItem.id, this.selectItem.orderNo, {
            lineColor: "#000000",
            width: 1.3,
            height: 40,
            fontSize: 15,
            displayValue: true,
            margin: 0,
            marginTop: 5,
          });
        })
      }
    },
  },
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {

  },
  // html加载完成后执行。
  mounted() {
    for (let i = 0; i < this.personArray.length; i++) {
      let item = this.personArray[i]
      if (i === 0) {
        this.selectItem = this.$method.deepClone(item)
      }
    }
  },
  // 事件方法执行
  methods: {
    numberChange(e) {
      this.selectItem.doseNums = this.$method.checkInput(this.selectItem.doseNums, 0)
      if (Number(this.selectItem.doseNums) === 0) {
        this.selectItem.doseNums = ''
      }
      if (Number(this.selectItem.doseNums) > 50) {
        this.selectItem.doseNums = this.selectItem.doseNums.substring(0, this.selectItem.doseNums.length - 1)
      }
    },
    clickTab(item) {
      this.selectItem = this.$method.deepClone(item)
      if (!this.$method.isEmptyOrZero(this.selectItem.doseNums)) {
        this.$nextTick(() => {
          //条形码
          JsBarcode("#barcode" + this.selectItem.id, this.selectItem.orderNo, {
            lineColor: "#000000",
            width: 1.3,
            height: 40,
            fontSize: 15,
            displayValue: true,
            margin: 0,
            marginTop: 5,
          });
        })
      }
    },
    clickPrint() {
      if (this.$method.isEmptyOrZero(this.selectItem.doseNums)) {
        this.$message.error('请输入打印数量')
        return
      }
      this.printContent.id = 'print' + this.selectItem.id
      document.getElementById("printTransferCodeId").click();
    },
  },
}
</script>

<style lang="scss" scoped>
/*去除页眉页脚*/
@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}

html {
  background-color: #FFFFFF;
  margin: 0;
  /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px blue;
  margin: 10mm 15mm 10mm 15mm;
  /* margin you want for the content */
}

/*去除页眉页脚*/
.printTransferCode {
  width: 500px;
  height: 100%;
  font-size: 18px;
  margin: 0 30px;

  .line-grey {
    width: 100%;
    height: 2px;
    background: #F3F3F3;
  }
}
</style>
